/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_deposit_modal_instruction_1 = /** @type {(inputs: {}) => string} */ () => {
	return `Usa la dirección en asset-hub para identificar tu tarjeta`
};

const en_cards_deposit_modal_instruction_1 = /** @type {(inputs: {}) => string} */ () => {
	return `Use the asset-hub address to identify your card`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_deposit_modal_instruction_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_deposit_modal_instruction_1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_deposit_modal_instruction_1", locale)
	if (locale === "es") return es_cards_deposit_modal_instruction_1(inputs)
	return en_cards_deposit_modal_instruction_1(inputs)
};
export { cards_deposit_modal_instruction_1 as "cards.deposit_modal.instruction_1" }